import { init } from "@harbor/anchor/runtime";
import { initAnchorRuntimeProperty } from "../AppHOC/reducer";
import store from "../../store";
import {
  MFE_RUNTIME_STATUS,
  setMFERuntimeStatus,
} from "./MFERuntimeStatus";

export const loadConfigurationLocal = async (port = 3002) => {
  const configUrl = `http://localhost:${port}/ui-config.json`;
  try {
    const response = await fetch(configUrl);

    if (!response.ok) {
      console.warn(
        `Failed to load config from ${configUrl}: ${response.status} ${response.statusText}`,
      );
      return null;
    }

    return await response.json();
  } catch (err) {
    console.error("Failed to load ui-config.json from localhost:", err);
    throw err;
  }
};

export const initializeAnchor = async (configs) => {
  if (window._isAnchorLoaded === true) return;
  setMFERuntimeStatus(MFE_RUNTIME_STATUS.LOADING);
  try {
    // Uncomment for testing local ui config from unify ui dev server
    // const localConfigPromises = [loadConfigurationLocal()];
    // // run unify ui state mfe with port 3003 for local testing
    // // cd packages/core-ui/global-state-manager && pnpm start
    // localConfigPromises.push(loadConfigurationLocal(3003));
    // const allConfigs = await Promise.allSettled(localConfigPromises);
    // const successfulConfigs = allConfigs
    //   .filter((result) => result.status === "fulfilled" && result.value)
    //   .map((result) => result.value);
    // configs.push(...successfulConfigs);

    // Initialize Anchor
    init({
      configs,
      loadModule: async (assetRef) => {
        const exports = await import(/* webpackIgnore: true */ assetRef.js);
        return exports[assetRef.member];
      },
    });
    initAnchorRuntimeProperty(store);
    window._isAnchorLoaded = true;
    setMFERuntimeStatus(MFE_RUNTIME_STATUS.READY);
  } catch (error) {
    window._isAnchorLoaded = false;
    setMFERuntimeStatus(MFE_RUNTIME_STATUS.FAILED);
    console.error("Error initializing Anchor:", error);
    throw new Error(
      "Failed to initialize Anchor: " +
        (error && error.message ? error.message : "Unknown error"),
    );
  }
};
